import React, { useEffect, useState } from "react";
import axios from "axios";
import { baseUrl_SPB } from "../../../BaseUrl";
import { useAuth } from "../../../AuthProvider";

export default function StripeSuccessPage() {

  const [status, setStatus] = useState("checking");

  // optional: you can pass invoiceId via query param
  const query = new URLSearchParams(window.location.search);
  const sessionId = query.get("session_id");
  const invoiceId = query.get("invoiceId");
  const auth = useAuth();
  const checkStatus = async () => {
    try {

      const res = await axios.get(
        `${baseUrl_SPB}/api/v1/invoice/payment-status?sessionId=${sessionId}&invoiceId=${invoiceId}`,
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      );

      setStatus(res.data); // PAID / UNPAID / PENDING

    } catch (err) {
      console.error(err);
      setStatus("error");
    }
  };

  useEffect(() => {

    checkStatus();


  }, []);

  return (
    <div style={{ padding: 20 }}>

      <h2>Payment Successful 🎉</h2>

      {status === "checking" && <p>Confirming payment...</p>}

      {status === "PAID" && (
        <div>
          <p>✅ Payment confirmed</p>
          <p>Your invoice has been marked as paid.</p>
        </div>
      )}

      {status === "UNPAID" && (
        <div>
          <p>⏳ Payment still processing...</p>
          <p>Please wait a few seconds.</p>
        </div>
      )}

      {status === "error" && (
        <p>⚠️ Unable to verify payment. Please refresh.</p>
      )}

    </div>
  );
}